import { render, staticRenderFns } from "./learner-across-facets-chart.vue?vue&type=template&id=256578a3"
import script from "./learner-across-facets-chart.ts?vue&type=script&lang=ts&external"
export * from "./learner-across-facets-chart.ts?vue&type=script&lang=ts&external"
import style0 from "./learner-across-facets-chart.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports